import React from 'react'
import HydrocisLogo from '../../../../assets/images/HydrocisLogo.png';
import  Button  from '../reusable_ui/button/Button';
import { Navbar } from './styles/Nav.styled';
import { Link} from 'react-router-dom'

const Nav = () => {


  return (
    <Navbar>
     <div className='nav__logo'>
        <img src={HydrocisLogo} alt='hydrocis' />
     </div>

     <div  className='nav__row'>
       <>
        <div className='nav__list'>
          <li className='nav__item'> Home</li> 
          <li className='nav__item'>Services</li>
          <li className='nav__item'>Pricing </li>    
        </div>
       </>
       {" "}
        <div className='nav__btn'>
          <Link to='/'><Button color="#377DFF" bgColor='white'>Go to App</Button>  {' '}</Link>
          <></>
         <Link to='/user/login'><Button> Sign In</Button></Link> 
        </div>

     </div>
    </Navbar>
  )
}

export default Nav